import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrl: './authenticate.component.scss',
  imports: [TranslateModule, RouterModule]
})
export class AuthenticateComponent implements OnInit {
  constructor(private route: ActivatedRoute, private changeDetection: ChangeDetectorRef, private router: Router,
  ) {
  }
  hasErrorSignIn: boolean = false;
  hasError!: boolean;
  logout() {
    // this.authService.logoutothersesstions(this.f.email.value);
    // this.hasErrorSignIn = false;
    // this.changeDetection.detectChanges();
    this.router.navigateByUrl("/auth/signout-others");


  }
  ngOnInit(): void {
    // debugger
    const Token = this.route.snapshot.queryParamMap.get('Token');
    const IsLoggedIn = this.route.snapshot.queryParamMap.get('IsLoggedIn');

    const IsAuthenticated = this.route.snapshot.queryParamMap.get('IsAuthenticated');

    if (IsLoggedIn == "True") {
      this.hasErrorSignIn = true;
      this.changeDetection.detectChanges();
    }
    else {
      if (IsAuthenticated == "True") {
        // debugger
        this.hasError = false;
        localStorage.setItem("token", Token!);
        // debugger
        this.router.navigateByUrl("/home");
      }
      else {
        this.hasError = true;
        this.changeDetection.detectChanges();

      }
      this.hasErrorSignIn = false;
      this.changeDetection.detectChanges();

    }
  }

}
